import {ArrowRight, NavPageMobile, SubNavs, SubNavsText, SubNavsTextLight} from "./Navbar/NavbarElements"
import arrowRight from '../assets/logos/arrowRight.svg'

const NavbarMobile = ({setIndex, goTo}) => {

    return <NavPageMobile>
        <SubNavs data-aos="fade-right" onClick={() => {
            setIndex(1)
        }}>
            <SubNavsText>
                PRODUCTS
            </SubNavsText>
            <ArrowRight src={arrowRight}/>
        </SubNavs>
        <SubNavs data-aos="fade-right" onClick={() => {
            setIndex(2)
        }}>
            <SubNavsText>
                ADVISORY
            </SubNavsText>
            <ArrowRight src={arrowRight}/>
        </SubNavs>
        <SubNavs data-aos="fade-right" onClick={() => {
            setIndex(3)
        }}>
            <SubNavsText>
                MANAGED SERVICES
            </SubNavsText>
            <ArrowRight src={arrowRight}/>
        </SubNavs>
        <SubNavs data-aos="fade-right" onClick={() => {
            setIndex(4)
        }}>
            <SubNavsText>
                ENGINEERING
            </SubNavsText>
            <ArrowRight src={arrowRight}/>
        </SubNavs>
        <SubNavs data-aos="fade-right" onClick={() => {
            setIndex(5)
        }}>
            <SubNavsText>
                ACADEMY
            </SubNavsText>
            <ArrowRight src={arrowRight}/>
        </SubNavs>
        <SubNavs id={'menu-labs-link'} data-aos="fade-right">
            <SubNavsText onClick={() => goTo('labs')}>
                LABS
            </SubNavsText>
        </SubNavs>
        <SubNavs id={'menu-resources-link'} data-aos="fade-right" onClick={() => {
            goTo('resources'); /*setIndex(6)*/
        }}>
            <SubNavsText>
                RESOURCES
            </SubNavsText>
            {/*<ArrowRight src={arrowRight} />*/}
        </SubNavs>
        <SubNavs data-aos="fade-right" id={'menu-contact-us-link'} onClick={() => goTo('contact-us')}>
            <SubNavsTextLight>
                CONTACT US
            </SubNavsTextLight>
        </SubNavs>
        <SubNavs data-aos="fade-right" id={'menu-about-us-link'} onClick={() => goTo('about-us')}>
            <SubNavsTextLight>
                ABOUT US
            </SubNavsTextLight>
        </SubNavs>
        <SubNavs data-aos="fade-right" id={'menu-careers-link'} onClick={() => goTo('careers')}>
            <SubNavsTextLight>
                CAREERS
            </SubNavsTextLight>
        </SubNavs>
    </NavPageMobile>
}

export default NavbarMobile;